import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {RoomState} from '../../../../../shared/RoomState'
import {AnalyticEventCategory, AnalyticEventType} from '../../../../../shared/entity_datas/EntityDatas'
import {clientI18n} from '../../../../shared/scripts/ClientI18n'
import {Sound} from '../../../../shared/scripts/Sound'
import {CA} from '../../../../shared/scripts/analytics/Analytics'

export class UIRoomCenterShareLinkController {
    private readonly linkTitle: HTMLHeadingElement
    private readonly link: HTMLInputElement
    private readonly linkButton: HTMLLinkElement

    constructor() {
        this.linkTitle = document.getElementById('room_center_link_title') as HTMLInputElement
        this.link = document.getElementById('room_center_link') as HTMLInputElement
        this.linkButton = document.getElementById('room_center_link_button') as HTMLLinkElement
    }

    load(roomState: RoomState) {
        if(this.link == undefined) return
        this.linkTitle.innerText = clientI18n.t('strings:roomPage.inviteFriendsTitle', {roomId: roomState.gameSetting.id})
        this.linkTitle.addEventListener('copy', () => {
            const selectedText = window.getSelection()?.toString()
            if(selectedText?.includes(roomState.gameSetting.id)) void this.sendCopyLinkEvent()
        })
        this.link.value = window.location.href.toLocaleLowerCase()
        this.link.addEventListener('copy', () => this.sendCopyLinkEvent())
        this.linkButton.innerText = clientI18n.t('strings:roomPage.options.inviteFriends.copy')
        this.linkButton.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)
            this.link.select()
            document.execCommand('copy')
            this.linkButton.innerText = clientI18n.t('strings:roomPage.copiedLink')
            void this.sendCopyLinkEvent()
        }
    }

    // eslint-disable-next-line class-methods-use-this
    private async sendCopyLinkEvent() {
        const copyLinkEvent: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.CopiedRoomLink,
            category: AnalyticEventCategory.Lobby,
        }
        void CA.sendAnalyticEventOnce(copyLinkEvent)
    }
}
